var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8904 4.80884L13.8491 4.78495L13.8491 4.78494C12.8123 4.18638 11.9765 3.70379 11.2667 3.39908C10.5321 3.0837 9.84366 2.91789 9.11264 3.04058C8.87696 3.08014 8.6456 3.14213 8.42172 3.22571C7.72729 3.48497 7.21401 3.97278 6.73549 4.61322C6.4436 5.00388 6.14364 5.48107 5.81152 6.04071C6.1914 5.94284 6.58967 5.89078 7.00011 5.89078H7.67039C7.76199 5.75332 7.85039 5.62711 7.93712 5.51105C8.32989 4.98536 8.63095 4.74873 8.94636 4.63097C9.08069 4.58082 9.21951 4.54362 9.36092 4.51989C9.69294 4.46417 10.072 4.51857 10.675 4.77744C11.2195 5.01119 11.8731 5.3778 12.764 5.89078H15.7644L13.8904 4.80884Z",
    fill: "#242220",
    fillOpacity: 0.69
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.89087C4.37665 5.89087 2.25 8.01752 2.25 10.6409V16.6409C2.25 19.2642 4.37665 21.3909 7 21.3909H17C19.5395 21.3909 21.6135 19.398 21.7435 16.8909H21.7497V16.6953C21.7499 16.6772 21.75 16.659 21.75 16.6409V10.6409C21.75 10.6227 21.7499 10.6046 21.7497 10.5865V10.3909H21.7435C21.6135 7.88373 19.5395 5.89087 17 5.89087H7ZM20.2405 10.3909C20.1129 8.71276 18.7108 7.39087 17 7.39087H7C5.20507 7.39087 3.75 8.84594 3.75 10.6409V16.6409C3.75 18.4358 5.20507 19.8909 7 19.8909H17C18.7108 19.8909 20.1129 18.569 20.2405 16.8909H16.5205C14.7256 16.8909 13.2705 15.4358 13.2705 13.6409C13.2705 11.8459 14.7256 10.3909 16.5205 10.3909H20.2405ZM14.7705 13.6409C14.7705 12.6744 15.554 11.8909 16.5205 11.8909H20.2497V15.3909H16.5205C15.554 15.3909 14.7705 14.6074 14.7705 13.6409Z",
    fill: "#242220",
    fillOpacity: 0.69
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5017,
    cy: 13.6407,
    r: 0.75,
    fill: "#242220",
    fillOpacity: 0.69
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.4de042fa5610c16a44f5285c34f086e0.svg";
export { ForwardRef as ReactComponent };